import type { Teammate } from "./types";

export function chatgptUrl(teammate: Teammate) {
  const preamble = `I built an AI teammate named ${teammate.name} in the Pfizer "Build Your AI Teammate" workshop, and I'd like to use it here.

Below is its reusable prompt template. It contains {placeholders} in curly braces — please read the template, then ask me for each placeholder one at a time in a natural conversation. Once I've given you all of them, run the task exactly as the template describes.

--- ${teammate.name}'s prompt template ---
${teammate.prompt}
--- end of template ---

Start by asking me for the first {placeholder} now.`;
  return `https://chatgpt.com/?q=${encodeURIComponent(preamble)}`;
}
